"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamCapability = void 0;
var TeamCapability;
(function (TeamCapability) {
    TeamCapability["SERVICE"] = "SERVICE";
    TeamCapability["COMMERCIE"] = "COMMERCIE";
    TeamCapability["DEURWAARDER"] = "DEURWAARDER";
    TeamCapability["INCASSO"] = "INCASSO";
    TeamCapability["BETALINGSVERWERKING"] = "BETALINGSVERWERKING";
    TeamCapability["KLACHTEN"] = "KLACHTEN";
    TeamCapability["GESCHILLEN"] = "GESCHILLEN";
    TeamCapability["RETOURPOST"] = "RETOURPOST";
    TeamCapability["WEBCARE"] = "WEBCARE";
    TeamCapability["BERICHTENVERKEER"] = "BERICHTENVERKEER";
    TeamCapability["FACTURATIE"] = "FACTURATIE";
    TeamCapability["BOETES"] = "BOETES";
    TeamCapability["OTA"] = "OTA";
    TeamCapability["RENTAL"] = "RENTAL";
    TeamCapability["PRULLENBAK"] = "PRULLENBAK";
    TeamCapability["INCASSO_SHV"] = "INCASSO_SHV";
})(TeamCapability = exports.TeamCapability || (exports.TeamCapability = {}));
